var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_218_10969)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.282 160.705C233.099 161.251 215.404 199.803 210.685 219.148C207.834 254.074 240.248 261.928 247.75 256.925C251.945 254.129 260.484 250.418 266.639 249.156C272.794 250.418 281.333 254.129 285.527 256.925C293.029 261.928 325.444 254.074 322.592 219.148C317.874 199.803 300.179 161.251 266.996 160.705V160.699C266.877 160.699 266.758 160.7 266.639 160.701C266.52 160.7 266.401 160.699 266.282 160.699V160.705Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.176 285.054L164.861 560H371.595L351.131 269.313C375.478 228.596 374.218 176.79 370.545 155.977C363.829 117.358 342.911 117.498 333.291 122.396C332.452 92.1725 321.746 87.2402 305.482 82.5179C281.868 79.3696 269.625 94.2362 265.078 104.031C265.078 93.0119 255.108 83.9732 247.762 82.5179C203.267 73.7029 195.294 105.43 194.769 122.396C185.954 117.778 172.05 122.815 165.384 128.692C125.506 163.847 159.614 259.868 182.176 285.054Z",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.273,
    cy: 160.699,
    rx: 14.6918,
    ry: 16.7906,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 337.487,
    cy: 160.699,
    rx: 14.6918,
    ry: 16.7906,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.496,
    cy: 119.772,
    rx: 14.6918,
    ry: 16.7906,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 297.609,
    cy: 119.772,
    rx: 14.6918,
    ry: 16.7906,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.099 476.889L430.574 417.364",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.538,
    cy: 326.588,
    r: 107.084,
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.408 377.506C353.655 379.159 359.665 385.604 362.702 390.374C362.855 390.614 362.991 390.865 363.109 391.124C367.596 400.935 376.656 402.056 380.3 401.506C383.679 400.995 386.833 403.321 387.343 406.7C387.853 410.08 385.528 413.233 382.148 413.743C375.022 414.819 359.629 412.708 352.055 396.703C349.852 393.385 346.389 390.325 342.976 389.641C340.429 389.131 335.668 389.533 329.509 398.829C327.621 401.678 323.781 402.457 320.932 400.57C318.083 398.682 317.304 394.842 319.192 391.993C326.995 380.216 336.187 375.658 345.408 377.506Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.252 305.09C421.171 300.62 419.662 293.838 419.475 289.52C419.463 289.235 419.47 288.95 419.497 288.667C420.144 281.855 415.559 278.432 413.524 277.634C410.342 276.387 408.775 272.796 410.022 269.614C411.27 266.432 414.861 264.864 418.042 266.112C423.352 268.194 432.921 275.636 431.861 289.343C432.048 291.966 433.027 294.567 434.426 295.797C435.143 296.427 437.473 298.092 444.357 294.664C447.416 293.141 451.131 294.386 452.655 297.445C454.178 300.504 452.933 304.219 449.874 305.743C440.326 310.497 432.08 310.216 426.252 305.09Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.226 239.668C351.674 239.668 356.9 243.769 356.9 248.828L356.9 261.041C356.9 266.099 351.674 270.2 345.226 270.2C338.779 270.2 333.552 266.099 333.552 261.041L333.552 248.828C333.552 243.769 338.779 239.668 345.226 239.668Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.226 333.059C351.674 333.059 356.9 337.642 356.9 343.296L356.9 356.945C356.9 362.599 351.674 367.182 345.226 367.182C338.779 367.182 333.552 362.599 333.552 356.945L333.552 343.296C333.552 337.642 338.779 333.059 345.226 333.059Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.949 257.504C393.876 261.431 393.876 267.798 389.949 271.725L380.468 281.206C376.541 285.133 370.173 285.133 366.246 281.206C362.319 277.279 362.319 270.912 366.246 266.985L375.727 257.504C379.654 253.577 386.021 253.577 389.949 257.504Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.634 324.815C326.561 328.742 326.561 335.109 322.634 339.036L313.153 348.517C309.226 352.444 302.859 352.444 298.932 348.517C295.005 344.59 295.005 338.223 298.932 334.296L308.413 324.815C312.34 320.888 318.707 320.888 322.634 324.815Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.302 257.503C303.229 253.575 309.597 253.575 313.524 257.503L323.005 266.984C326.932 270.911 326.932 277.278 323.005 281.205C319.077 285.132 312.71 285.132 308.783 281.205L299.302 271.724C295.375 267.797 295.375 261.43 299.302 257.503Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.616 324.813C370.543 320.886 376.91 320.886 380.837 324.813L390.318 334.294C394.245 338.221 394.245 344.588 390.318 348.515C386.391 352.443 380.024 352.443 376.096 348.515L366.616 339.035C362.688 335.107 362.688 328.74 366.616 324.813Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.469 301.633C281.469 296.177 285.57 291.755 290.628 291.755L302.841 291.755C307.9 291.755 312.001 296.177 312.001 301.633C312.001 307.088 307.9 311.511 302.841 311.511L290.628 311.511C285.57 311.511 281.469 307.088 281.469 301.633Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.86 301.633C374.86 296.177 379.443 291.755 385.097 291.755L398.746 291.755C404.4 291.755 408.983 296.177 408.983 301.633C408.983 307.088 404.4 311.511 398.746 311.511L385.097 311.511C379.443 311.511 374.86 307.088 374.86 301.633Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.636 302.531C385.636 325.344 367.142 343.838 344.328 343.838C321.515 343.838 303.021 325.344 303.021 302.531C303.021 279.717 321.515 261.223 344.328 261.223C367.142 261.223 385.636 279.717 385.636 302.531Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.479 289.53C366.479 296.302 360.99 301.791 354.218 301.791C347.447 301.791 341.957 296.302 341.957 289.53C341.957 282.758 347.447 277.269 354.218 277.269C360.99 277.269 366.479 282.758 366.479 289.53Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.322 315.687C340.322 320.653 336.296 324.679 331.331 324.679C326.365 324.679 322.339 320.653 322.339 315.687C322.339 310.721 326.365 306.696 331.331 306.696C336.296 306.696 340.322 310.721 340.322 315.687Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.9 329.907C456.9 335.376 452.745 339.808 447.618 339.808C442.492 339.808 438.336 335.376 438.336 329.907C438.336 324.439 442.492 320.006 447.618 320.006C452.745 320.006 456.9 324.439 456.9 329.907Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.207 242.655C401.207 246.414 398.16 249.462 394.4 249.462C390.641 249.462 387.593 246.414 387.593 242.655C387.593 238.896 390.641 235.848 394.4 235.848C398.16 235.848 401.207 238.896 401.207 242.655Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.487 335.112C423.774 335.112 426.439 337.203 426.439 339.782L426.439 346.009C426.439 348.588 423.774 350.679 420.487 350.679C417.2 350.679 414.535 348.588 414.535 346.009L414.535 339.782C414.535 337.203 417.2 335.112 420.487 335.112Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.487 382.729C423.774 382.729 426.439 385.065 426.439 387.948L426.439 394.907C426.439 397.79 423.774 400.126 420.487 400.126C417.2 400.126 414.535 397.79 414.535 394.907L414.535 387.948C414.535 385.065 417.2 382.729 420.487 382.729Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.289 344.204C445.291 346.207 445.291 349.453 443.289 351.455L438.455 356.289C436.453 358.291 433.207 358.291 431.205 356.289C429.202 354.287 429.202 351.041 431.205 349.038L436.038 344.204C438.041 342.202 441.287 342.202 443.289 344.204Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.969 378.526C410.971 380.528 410.971 383.774 408.969 385.777L404.135 390.61C402.133 392.613 398.887 392.613 396.885 390.61C394.882 388.608 394.882 385.362 396.885 383.36L401.718 378.526C403.721 376.524 406.967 376.524 408.969 378.526Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.073 344.205C399.075 342.202 402.321 342.202 404.324 344.205L409.158 349.039C411.16 351.041 411.16 354.287 409.158 356.289C407.155 358.292 403.909 358.292 401.907 356.289L397.073 351.455C395.071 349.453 395.071 346.207 397.073 344.205Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.392 378.525C433.395 376.523 436.641 376.523 438.643 378.525L443.477 383.359C445.479 385.361 445.479 388.607 443.477 390.61C441.475 392.612 438.229 392.612 436.226 390.61L431.392 385.776C429.39 383.774 429.39 380.527 431.392 378.525Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.981 366.704C387.981 363.923 390.072 361.668 392.651 361.668H398.877C401.456 361.668 403.547 363.923 403.547 366.704C403.547 369.485 401.456 371.74 398.877 371.74H392.651C390.072 371.74 387.981 369.485 387.981 366.704Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.596 366.704C435.596 363.923 437.933 361.668 440.816 361.668L447.775 361.668C450.657 361.668 452.994 363.923 452.994 366.704C452.994 369.485 450.657 371.74 447.775 371.74L440.816 371.74C437.933 371.74 435.596 369.485 435.596 366.704Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.09 367.162C441.09 378.794 431.661 388.223 420.029 388.223C408.398 388.223 398.969 378.794 398.969 367.162C398.969 355.531 408.398 346.102 420.029 346.102C431.661 346.102 441.09 355.531 441.09 367.162Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.245 361.01C432.245 364.617 429.321 367.542 425.713 367.542C422.105 367.542 419.181 364.617 419.181 361.01C419.181 357.402 422.105 354.478 425.713 354.478C429.321 354.478 432.245 357.402 432.245 361.01Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.31 374.945C418.31 377.591 416.165 379.736 413.52 379.736C410.874 379.736 408.73 377.591 408.73 374.945C408.73 372.3 410.874 370.155 413.52 370.155C416.165 370.155 418.31 372.3 418.31 374.945Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_218_10969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/피부과_농피증.cdf9e0dfc2975efca36bff37a58a3203.svg";
export { ForwardRef as ReactComponent };